import { Nav, Navbar, Row, Col, Container, NavDropdown } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useAuth } from "../../components/AuthContext";
import { auth, db } from "../../config/Firebase";
import "./Navigation.css";
import "../../components/CalendarApp/TourModal.css";
import { FaSignInAlt, FaSignOutAlt } from "react-icons/fa";
import { useEffect, useState } from "react";

const Navigation = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState({
    eventUserApprovalEnabled: false,
    contestUserApprovalEnabled: false,
  });
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const handleInstall = () => {
    if (!installPrompt) {
      return;
    }
    installPrompt.prompt();
    installPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
      setInstallPrompt(null);
    });
  };

  return (
    <div className="background-image">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="text-center text-md-start w-100 w-md-auto">
          <a href="https://diariomuralcurico.cl">
            <img
              alt="Logo Diario Mural Curicó"
              src="/images/lgdmcfull.png"
              className="logoMuralNav mx-auto p-3"
            />
          </a>
        </div>
        <Container
          fluid
          className="d-flex justify-content-center justify-content-md-end"
        >
          <div className="d-flex align-items-center">
            <Col xs="auto">
              <Navbar expand="lg" className="w-100">
                <Container fluid>
                  <div className="d-flex d-lg-none">
                    <NavDropdown
                      title="Publicar"
                      id="offcanvasNavbarDropdown-mobile"
                      className="btnLink modern-button text-white rounded fw-bold fs-6 m-1 p-2"
                    >
                      <NavDropdown.Item href="/publicar">
                        Actividades
                      </NavDropdown.Item>
                      <NavDropdown.Item href="/concursos">
                        Concursos
                      </NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link
                      href="/"
                      className="btnLink rounded fw-bold fs-6 m-1 p-2"
                    >
                      Actividades
                    </Nav.Link>
                  </div>
                  <Navbar.Toggle
                    aria-controls="offcanvasNavbar-expand-sm"
                    className="btnLink rounded fw-bold fs-6 m-1 p-2"
                  />
                  <Navbar.Offcanvas
                    id="offcanvasNavbar-expand-sm"
                    aria-labelledby="offcanvasNavbarLabel-expand-sm"
                    placement="end"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title id="offcanvasNavbarLabel-expand-sm">
                        <img
                          alt="Logo"
                          style={{ textDecoration: "none", color: "white" }}
                          src="/images/logoencabezado.png"
                          className="logoMuralBlack d-inline-block align-top"
                        />
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Nav className="justify-content-end flex-grow-1 align-items-center flex-wrap">
                        <NavDropdown
                          title="Publicar"
                          id="offcanvasNavbarDropdown-desktop"
                          className="btnLink modern-button text-white rounded fw-bold fs-6 m-1 p-1 d-none d-lg-flex"
                        >
                          <NavDropdown.Item href="/publicar">
                            Actividades
                          </NavDropdown.Item>
                          <NavDropdown.Item href="/concursos">
                            Concursos
                          </NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link
                          href="/"
                          className="btnLink rounded fw-bold fs-6 m-1 p-2 d-none d-lg-flex"
                        >
                          Actividades
                        </Nav.Link>
                        <Nav.Link
                          href="/suena-curico"
                          className="btnLink rounded fw-bold fs-6 m-1 p-2"
                        >
                          Sueña Curicó
                        </Nav.Link>
                        <Nav.Link
                          href="/quienes-somos"
                          className="btnLink rounded fw-bold fs-6 m-1 p-2"
                        >
                          Nosotros
                        </Nav.Link>
                        {user ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-logout">
                                Cerrar Sesión
                              </Tooltip>
                            }
                          >
                            <button
                              onClick={handleLogout}
                              className="btnLink rounded fw-bold fs-6 m-1 p-2"
                            >
                              <FaSignOutAlt />
                            </button>
                          </OverlayTrigger>
                        ) : (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-login">
                                Iniciar Sesión
                              </Tooltip>
                            }
                          >
                            <Nav.Link
                              href="/login"
                              className="btnLink rounded fw-bold fs-6 m-1 p-2"
                            >
                              <FaSignInAlt />
                            </Nav.Link>
                          </OverlayTrigger>
                        )}
                      </Nav>
                      <Row className="d-block d-lg-none align-items-center justify-content-center text-start mt-4">
                        <Col xs="auto">
                          <a
                            href="https://www.instagram.com/diariomuralcurico/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              alt="Instagram"
                              src="/images/instagram.png"
                              height="40"
                              className="iconsRedes m-1 d-inline-block"
                            />
                          </a>
                          <a href="mailto:diariomuralcurico@gmail.com">
                            <img
                              alt="Correo"
                              src="/images/correo.png"
                              height="50"
                              className="iconsRedes m-1 d-inline-block align-top"
                            />
                          </a>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip-install">
                                La aplicación no se puede instalar en este
                                momento.
                              </Tooltip>
                            }
                          >
                            <span className="d-inline-block">
                              <button
                                onClick={handleInstall}
                                className="btnLink rounded fw-bold fs-6 m-1 p-2"
                                disabled={!installPrompt}
                                style={{
                                  pointerEvents: !installPrompt
                                    ? "none"
                                    : "auto",
                                }}
                              >
                                Instalar App
                              </button>
                            </span>
                          </OverlayTrigger>
                        </Col>
                      </Row>
                    </Offcanvas.Body>
                  </Navbar.Offcanvas>
                </Container>
              </Navbar>
            </Col>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Navigation;
